// extracted by mini-css-extract-plugin
export default {"root":"AZPU9O9DDQI6l1tWYK3L","message":"PHSCwGfmqa_BMXDkbARh","placeHolderShimmer":"yeiMt2RraQkmkU6srfdv"};